import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import { ToastContainer } from "react-toastify";
import VerifyPasswordHook from "../../hook/auth/verify-password-hook";
import { validateSixDigitPhoneNumber } from "../../Feature/codeValid";
import ValidTORMessages from "./ValidMessages/ValidMessages";
const VerifyPasswordPage = () => {
  const [code, OnChangeCode, onSubmit, isComplate] = VerifyPasswordHook();

  return (
    <Container style={{ minHeight: "690px" }}>
      <Row className="py-5 d-flex justify-content-center ">
        <Col sm="12" className="d-flex flex-column ">
          <label className="mx-auto title-login">
            ادخل الكود المرسل فى الايميل
          </label>
          <input
            value={code}
            onChange={OnChangeCode}
            placeholder="ادخل الكود..."
            type="email"
            className="user-input my-3 text-center mx-auto"
          />

          <div className="mx-auto mt-2">
            {code.length > 1 ? (
              <ValidTORMessages
                validlistError={validateSixDigitPhoneNumber(code)}
              />
            ) : null}
          </div>

          {isComplate ? (
            <button onClick={onSubmit} className="btn-login mx-auto mt-2">
              تاكيد
            </button>
          ) : (
            <button
              disabled
              className="bg-grey-500 btn  mx-auto mt-2"
              style={{
                cursor: "not-allowed",
              }}
            >
              تاكيد
            </button>
          )}
        </Col>
      </Row>
      <ToastContainer />
    </Container>
  );
};
export default VerifyPasswordPage;
